import type {ToastProps} from '@Components/toast/toast.types';

export interface DismissibleToastProps extends ToastProps {
  duration?: number;
}

export const DEFAULT_DURATION = 3000;
